import makeStyles from '@mui/styles/makeStyles'

const bp = 'md'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.08)',
    borderRadius: '0.5rem',
    maxHeight: '100%',
    backgroundColor: 'white',
    maxWidth: '1600px'
  },

  header: {
    zIndex: 1,
    position: 'sticky',
    top: '0',
    borderBottom: '1px solid #C6C6C6',
    boxSizing: 'border-box'
  },

  headerBG: {
    zIndex: -1,
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    background: '#f0f0f0'
  },

  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '24px 24px 12px 24px',
    background: 'white'
  },

  headerTitleArea: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    height: '30px'
  },

  title: {
    marginRight: '16px',
    fontSize: theme.size.xl,
    color: '#1F1F1F'
  },

  search: {
    height: '30px',

    '& > input': {
      padding: '4px 16px'
    }
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '30px',

    [theme.breakpoints.down(bp)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',

      '& > :not(:last-child)': {
        marginBottom: '0.5rem'
      }
    }
  },

  checkbox: {
    marginRight: '8px',
    cursor: 'pointer'
  },

  text: {
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    userSelect: 'none'
  },

  menuRoot: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 24px 0 8px',
    border: '1px solid #C6C6C6',
    borderRadius: '8px',
    boxSizing: 'border-box',
    width: '148px',
    height: '30px',
    padding: '6px 16px',
    cursor: 'pointer',
    fontSize: theme.size.base,
    background: '#F5F6F8'
  },

  arrowIcon: {
    marginLeft: 'auto',
    height: 'auto',
    width: '10px',
    opacity: '0.7',
    cursor: 'pointer'
  },

  tabs: {
    display: 'flex',
    alignItems: 'center',

    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  },

  markRead: {
    marginLeft: 'auto',
    height: '30px',
    padding: '0 8px',
    width: 'auto',

    [theme.breakpoints.down(bp)]: {
      marginLeft: '0'
    }
  },

  empty: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1rem',
    marginBottom: '1rem',
    color: '#7f8487',
    opacity: '0.7'
  }
}))

export default useStyles
